{
  "name": "envestboard-ui",
  "version": "1.73.0",
  "scripts": {
    "ng": "ng",
    "api:gen": "orval --config ./orval.config.mjs",
    "start": "npm run i18n:cache-busting && node generate-version.js && ng serve",
    "start-target": "npm run i18n:cache-busting && node generate-version.js && ng serve --configuration $BUILD_ENV",
    "build": "npm run i18n:cache-busting && node generate-version.js && ng build --configuration $BUILD_ENV",
    "test": "ng test",
    "test:watch": "ng test --watch",
    "lint": "npm run i18n:cache-busting && ng lint",
    "lint:styles": "stylelint 'src/**/*.scss'",
    "lint:fix": "npm run lint -- --fix && stylelint \"src/**/*.scss\" --fix",
    "i18n:cache-busting": "node ./i18n-cache-busting.js",
    "i18n:extract": "transloco-keys-manager extract",
    "i18n:find": "transloco-keys-manager find",
    "prepare": "husky && (git config merge.theirs.driver 'cp -f %B %A' 2>/dev/null || true)",
    "push": "git push",
    "push:review": "REVIEW=1 git push",
    "push:review:force": "REVIEW=1 git push --force-with-lease",
    "review": "sh scripts/review.sh",
    "review:code": "sh scripts/review.sh code",
    "review:security": "sh scripts/review.sh security",
    "review:perf": "sh scripts/review.sh perf",
    "review:a11y": "sh scripts/review.sh a11y",
    "pw:install": "playwright install",
    "pw:test": "playwright test --project=mocked",
    "pw:test:live": "playwright test --project=live",
    "pw:test:auth": "playwright test --project=live-auth",
    "pw:test:ui": "playwright test --project=mocked --ui",
    "pw:test:ui:live": "playwright test --project=live --ui",
    "pw:test:headed": "playwright test --project=mocked --headed",
    "pw:report": "playwright show-report",
    "pw:codegen": "tsx e2e-playwright/scripts/codegen.ts",
    "pw:flows": "tsx e2e-playwright/scripts/flows.ts",
    "pw:flows:check": "tsx e2e-playwright/scripts/flows.ts --check",
    "pw:testids": "tsx e2e-playwright/scripts/testids.ts",
    "pw:kill": "tsx e2e-playwright/scripts/kill-codegen.ts",
    "pw:clean": "tsx e2e-playwright/scripts/clean-recordings.ts",
    "pw:check": "npm run pw:testids && npm run pw:flows:check && npm run pw:masked",
    "pw:record": "tsx e2e-playwright/scripts/record-fingerprints.ts",
    "compodoc:build": "compodoc -p tsconfig.doc.json",
    "compodoc:build:json": "compodoc -p tsconfig.doc.json -e json -d .",
    "compodoc:build-and-serve": "compodoc -p tsconfig.doc.json -s",
    "compodoc:serve": "compodoc -s",
    "storybook": "ng run envestboard-ui:storybook",
    "storybook:build": "ng run envestboard-ui:build-storybook",
    "bundle-report": "ng build --configuration production --source-map && source-map-explorer dist/**/*.js --html source-map-explorer.html",
    "eb:testing:start": "npm start -- --configuration testing",
    "eb:uat:start": "npm start -- --configuration uat",
    "eb:develop:start": "npm start -- --configuration development",
    "eb:prod:start": "npm start -- --configuration production",
    "eb:testing-chremyle:start": "npm start -- --configuration testing-chremyle",
    "eb:install": "npm install --legacy-peer-deps",
    "pw:har": "tsx e2e-playwright/scripts/har-payloads.ts",
    "pw:faults": "tsx e2e-playwright/scripts/fault-injection.ts",
    "pw:masked": "tsx e2e-playwright/scripts/masked-inputs.ts"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.2.4",
    "@angular/cdk": "^21.2.2",
    "@angular/common": "^21.2.4",
    "@angular/compiler": "^21.2.4",
    "@angular/core": "^21.2.4",
    "@angular/forms": "^21.2.4",
    "@angular/material": "^21.2.2",
    "@angular/material-date-fns-adapter": "^21.2.2",
    "@angular/platform-browser": "^21.2.4",
    "@angular/platform-browser-dynamic": "^21.2.4",
    "@angular/router": "^21.2.4",
    "@jsverse/transloco": "^7.4.3",
    "@jsverse/transloco-locale": "^7.0.1",
    "@jsverse/transloco-messageformat": "^7.0.1",
    "@ngneat/input-mask": "^6.1.0",
    "@ngneat/until-destroy": "^10.0.0",
    "@ngrx/signals": "^21.0.0",
    "@ngx-dropzone/cdk": "^21.0.0",
    "@ngx-dropzone/material": "^21.0.0",
    "@ngxs/devtools-plugin": "^21.0.0",
    "@ngxs/logger-plugin": "^21.0.0",
    "@ngxs/router-plugin": "^21.0.0",
    "@ngxs/storage-plugin": "^21.0.0",
    "@ngxs/store": "^21.0.0",
    "@sentry/angular": "^10.43.0",
    "@videogular/ngx-videogular": "^20.0.0",
    "angular-svg-icon": "^19.1.1",
    "broadcastchannel-polyfill": "^1.0.1",
    "clsx": "^2.1.1",
    "date-fns": "^3.6.0",
    "echarts": "^5.5.1",
    "exceljs": "^4.4.0",
    "file-saver": "^2.0.5",
    "flag-icons": "^7.2.3",
    "inputmask": "^5.0.9",
    "js-big-decimal": "^2.1.0",
    "jwt-decode": "^4.0.0",
    "libphonenumber-js": "^1.11.5",
    "moize": "^6.1.6",
    "ngx-drag-scroll": "^21.0.0",
    "ngx-dropzone": "^3.1.0",
    "ngx-echarts": "^21.0.0",
    "ngx-extended-pdf-viewer": "^25.6.4",
    "ngx-image-cropper": "^9.1.6",
    "ngx-infinite-scroll": "^21.0.0",
    "ngx-skeleton-loader": "^12.0.0",
    "ngx-vest-forms": "^1.1.0",
    "normalize.css": "^8.0.1",
    "ramda": "^0.30.1",
    "rxjs": "~7.8.1",
    "scrollbooster": "^3.0.2",
    "tslib": "^2.6.3",
    "uid": "^2.0.2",
    "vest": "5.4.6",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^21.2.2",
    "@angular-eslint/builder": "^21.3.1",
    "@angular-eslint/eslint-plugin": "^21.3.1",
    "@angular-eslint/eslint-plugin-template": "^21.3.1",
    "@angular-eslint/schematics": "^21.3.1",
    "@angular-eslint/template-parser": "^21.3.1",
    "@angular/build": "^21.2.2",
    "@angular/cli": "^21.2.2",
    "@angular/compiler-cli": "^21.2.4",
    "@commitlint/cli": "^21.0.0",
    "@commitlint/config-conventional": "^21.0.0",
    "@compodoc/compodoc": "^1.1.12",
    "@eslint/js": "^10.0.1",
    "@faker-js/faker": "^9.0.0",
    "@jsverse/transloco-keys-manager": "^5.1.0",
    "@playwright/test": "^1.58.2",
    "@semantic-release/changelog": "^6.0.3",
    "@semantic-release/exec": "^7.1.0",
    "@semantic-release/git": "^10.0.1",
    "@semantic-release/npm": "^13.1.5",
    "@storybook/addon-a11y": "^10.2.19",
    "@storybook/addon-docs": "^10.2.19",
    "@storybook/addon-links": "^10.2.19",
    "@storybook/addon-themes": "^10.2.19",
    "@storybook/angular": "^10.2.19",
    "@types/file-saver": "^2.0.7",
    "@types/inputmask": "^5.0.7",
    "@types/node": "^22.1.0",
    "@types/ramda": "^0.30.1",
    "@types/scrollbooster": "^3.0.3",
    "@typescript-eslint/eslint-plugin": "^8.57.1",
    "@typescript-eslint/parser": "^8.57.1",
    "angular-eslint": "^21.3.1",
    "eslint": "^10.0.3",
    "globals": "^16.0.0",
    "husky": "^9.1.7",
    "jsdom": "^29.0.0",
    "lint-staged": "^17.0.0",
    "orval": "^8.8.0",
    "prettier": "^3.8.1",
    "prettier-plugin-organize-attributes": "^1.0.0",
    "semantic-release": "^25.0.3",
    "source-map-explorer": "^2.5.3",
    "storybook": "^10.2.19",
    "stylelint": "^17.4.0",
    "stylelint-config-idiomatic-order": "^10.0.0",
    "stylelint-config-standard-scss": "^17.0.0",
    "stylelint-order": "^8.1.1",
    "stylelint-selector-bem-pattern": "^5.0.0",
    "tsx": "^4.21.0",
    "typescript": "^5.9.3",
    "typescript-eslint": "^8.57.1",
    "vitest": "^4.1.0"
  },
  "resolutions": {},
  "overrides": {
    "webpack": "5.107.2"
  }
}
